import { isTenantId } from '@lib/utils/tenant';
import useAuth from '@modules/AuthModule/hooks/useAuth';

export const UNKNOWN_TENANT_NAME = 'Unknown';

function useTenantName(tenantNameOrId: string, name?: string): string {
  const auth = useAuth();

  if (name) {
    return name;
  }

  if (!isTenantId(tenantNameOrId)) {
    return tenantNameOrId;
  }

  const tenant = auth.user?.org.tenants.find(
    (tenant) => tenant.id === tenantNameOrId,
  );

  return tenant?.companyName || (tenant?.name ?? UNKNOWN_TENANT_NAME);
}

export default useTenantName;
